import {reactive} from '../../libs/petite-vue.js';
export const store = reactive({
	cart: window.wpCartData?.cart || null,
	checkout: window.wpCartData?.checkout || null,
	delivery: {
		methods: {},
	},
	payment: {
		methods: {},
	},
	showRotateLogo: false,
	SendAjaxRequest(data = {}) {
		if (!window.wpData?.ajaxUrl) {
			return Promise.reject('wpData.ajaxUrl не определён');
		}
		const body = new URLSearchParams(data).toString();
		return fetch(wpData.ajaxUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body
		})
		.then(response => {
			if (!response.ok) {
				throw new Error(`HTTP ${response.status}`);
			}
			return response.json();
		});
	},
});
